import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Th,
  Td,
  StatusTag,
  TextButton,
  InlineSpinner,
} from "@graffer-inc/console-design-kit";
import {
  ApprovableStatuses,
  CancelableStatuses,
  type ProductDataRemovalTask,
  StatusLabel,
  StatusTagColor,
} from "../../../../application/domain/product-data-removal-task";
import { formatDatetime, formatDateRange } from "../../../../utils/date-utils";

type ProductDataRemovalTasksTableProps = {
  tasks: ProductDataRemovalTask[];
  isLoading: boolean;
  onApprove: (task: ProductDataRemovalTask) => void;
  onCancel: (task: ProductDataRemovalTask) => void;
};

export const ProductDataRemovalTasksTable = ({
  tasks,
  isLoading,
  onApprove,
  onCancel,
}: ProductDataRemovalTasksTableProps) => {
  return (
    <Table borderType="row">
      <TableHeader>
        <TableRow>
          <Th>ステータス</Th>
          <Th>登録日時</Th>
          <Th>期限日</Th>
          <Th>対象件数</Th>
          <Th>削除実施日</Th>
          <Th>承認</Th>
          <Th>キャンセル</Th>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          <TableRow>
            <Td colSpan={7}>
              <InlineSpinner />
            </Td>
          </TableRow>
        ) : tasks.length === 0 ? (
          <TableRow>
            <Td colSpan={7}>
              <p>まだデータがありません</p>
            </Td>
          </TableRow>
        ) : (
          tasks.map((task) => (
            <TableRow key={task.id}>
              <Td>
                <StatusTag type={StatusTagColor[task.status]}>
                  {StatusLabel[task.status]}
                </StatusTag>
              </Td>
              <Td>{formatDatetime(task.createdAt)}</Td>
              <Td>{formatDatetime(task.dueAt)}</Td>
              <Td>{task.targetCount.toLocaleString()}</Td>
              <Td>
                {task.processStartedAt
                  ? formatDateRange(task.processStartedAt, task.processEndedAt)
                  : ""}
              </Td>
              <Td>
                <TextButton
                  text={task.approvedAt ? "承認済み" : "承認"}
                  icon="CheckboxIcon"
                  disabled={!ApprovableStatuses.includes(task.status)}
                  onClick={() => onApprove(task)}
                />
              </Td>
              <Td>
                <TextButton
                  text={task.canceledAt ? "キャンセル済み" : "キャンセル"}
                  icon="TrashIcon"
                  disabled={!CancelableStatuses.includes(task.status)}
                  onClick={() => onCancel(task)}
                />
              </Td>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};
